import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  bounce_right_to_left_variants,
  bounce_right_to_left_variants_delay
} from "shared/components/animations";
import waitingPlayersBg from "assets/images/sbs/tot-new/waiting-players-bg.png";
import { ReactComponent as TopJoining } from "assets/images/tot/joining-top.svg";
import { ReactComponent as TopOver } from "assets/images/tot/over-top.svg";

const TOTJoining = ({ users, isOver }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="tot-joining"
    >
      <motion.div variants={bounce_right_to_left_variants}>
        {isOver ? (
          <TopOver className="top-banner" />
        ) : (
          <TopJoining className="top-banner" />
        )}
      </motion.div>

      <motion.div
        variants={bounce_right_to_left_variants_delay}
        className="tot-players-bg"
      >
        <img src={waitingPlayersBg} alt="" />
        <div className="tot-players-div">
          <div className="tot-players-flex">
            {users.map((user) => (
              <div key={user.user_id} className="waiting-users">
                <img
                  src={user.profile_image}
                  className="waitingPlayerImg"
                  alt=""
                />
                <p className="user">{user.display_name}</p>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default TOTJoining;
